import type { AllRouteEndpoints } from "../routeTypes";

// If applicable consider also updating engagementLandingPagesAppGroupIdLandingPageIdCacheKeys
export const postEngagementLandingPagesAppGroupIdLandingPageIdCopyTargetAppGroupIdCacheKeys: AllRouteEndpoints[] = [
  // There's no need to clear the cache. We navigate after copy to the target LP in the other workspace.
];
